import { Client } from '@suntex.fim/api-client';
import { AuthService } from '@suntex.fim/auth';
import { Locale } from '@suntex.fim/enums';
import { FrameworkProviderForClassic } from '@suntex.fim/framework';

type WithFrameworkProps = {
  api: Client;
  auth: AuthService;
  locale: Locale;
  onSoundToggle?: (disabled: boolean) => void;
  initialSoundDisabled?: boolean;
};

/**
 * Wraps a component for use in classic FIM.
 *
 * @param Component - The component to wrap
 * @returns A wrapped component ready for classic FIM integration
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function wrapForClassic<C extends React.FunctionComponent<any>>(
  Component: C,
) {
  type OriginalProps = React.ComponentProps<C>;
  type WrappedProps = Omit<OriginalProps, keyof WithFrameworkProps> &
    WithFrameworkProps;

  return function WrappedForClassic({
    api,
    auth,
    locale,
    onSoundToggle,
    initialSoundDisabled,
    ...props
  }: WrappedProps): JSX.Element {
    return (
      <FrameworkProviderForClassic
        api={api}
        auth={auth}
        locale={locale}
        onSoundToggle={onSoundToggle}
        initialSoundDisabled={initialSoundDisabled}
      >
        <Component {...(props as OriginalProps)} />
      </FrameworkProviderForClassic>
    );
  };
}
